module.exports = {"511503001":"南溪街道","511503002":"罗龙街道","511503102":"刘家镇","511503103":"江南镇","511503104":"大观镇","511503105":"汪家镇","511503106":"黄沙镇","511503107":"仙临镇","511503108":"长兴镇","511503109":"裴石镇","511503201":"马家乡","511503203":"大坪乡","511503204":"石鼓乡","511503205":"林丰乡","511503206":"留宾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511503.json
// module id = 2173
// module chunks = 0